import React from 'react'
import { MailDatesCell, MailRef } from '../../styles'
import { useTranslation } from 'react-i18next'
import { Table } from 'antd'
import Mail from 'globals/models/Mail'
import MailProcessing from 'components/MailProcessing'
import { ReactComponent as ArrowRightIcon } from 'globals/icons/chevron-right.svg'
import DataTable from 'components/DataTable'
import { format } from 'date-fns'

interface IProps {
  data: Mail[],
  selectedMailsIds: React.Key[],
  setSelectedMailsIds: (selectedMailsIds: React.Key[]) => void,
  onMailClicked: (mail: Mail) => void,
  hideHeader?: boolean,
  currentPage?: number,
  pageSize?: number,
  showPackages?: boolean,
  alwaysHideCheckboxes?: boolean,
  alwaysShowCheckboxes?: boolean,
  showAddTrackingNumber?: boolean,
  disable?: boolean,
  quickAction?: string,
  quickActionCallback?: any
}

const DataTableClientHistory = (props: IProps) => {
  const { data, selectedMailsIds, setSelectedMailsIds, hideHeader, currentPage,
    pageSize, alwaysHideCheckboxes, alwaysShowCheckboxes, onMailClicked,
    disable } = props
  const { t } = useTranslation()

  return (
    <DataTable
      data={data}
      selectedData={selectedMailsIds}
      setSelectedData={setSelectedMailsIds}
      currentPage={currentPage}
      pageSize={pageSize}
      shouldHideCheckbox={(mail) =>
        alwaysHideCheckboxes || (!alwaysShowCheckboxes && mail.physicalLocation !== 'business_center')
      }
      hideHeader={hideHeader}
      selectableRows
      disable={disable}
      onRow={(mail: Mail) => {
        return {
          onClick: () => {
            onMailClicked(mail)
          }
        }
      }}
    >
      <Table.Column
        key="id"
        dataIndex="id"
        title={t('mails.ref')}
        className="small"
        width={250}
        render={(id, mail: Mail) =>
          <MailRef>{mail.idScaneco}{mail.idScaneco && <br />}ID : {id}</MailRef>
        }
      />

      <Table.Column
        key="processingStatus"
        dataIndex="mailType"
        title={t('mails.processing-status')}
        className="medium"
        width={450}
        render={(type, mail: Mail) =>
          <MailDatesCell>
            <p>
              {t('mails.types.' + type)}
              {mail.weight && ` (${mail.weight}g)`}
              {mail.dateOfReceipt && ` recu le ${format(new Date(mail.dateOfReceipt), 'dd/MM/yyyy')}`}
            </p>
            <MailProcessing
              processingType={mail.processingType}
              processingDate={mail.processingDate}
              customerRequest={mail.hasUserRequest}
            />
          </MailDatesCell>
        }
      />

      <Table.Column
        key="sendName"
        dataIndex="sendName"
        title={t('mails.sender')}
        render={(sendName) => sendName || '-' }
      />

      <Table.Column
        key="action"
        title=""
        width={40}
        render={(t, mail: Mail) =>
          <ArrowRightIcon onClick={() => onMailClicked(mail)} />
        }
      />
    </DataTable>
  )
}

export default DataTableClientHistory
